/**
 * Aplicação de Exames Ocupacionais (#606): o inventário comum (`InventarioDoDestino`) com a configuração de exames — para
 * quem, o que já vale ali e o botão para adicionar mais, tudo gravado na hora.
 */
import { InventarioDoDestino } from '../../components/applications/InventarioDoDestino';
import { usePermissoesDaAplicacao } from '../../components/applications/permissoesDaAplicacao';
import { CONFIG_DE_EXAMES } from './configDeExames';

const MIGALHAS = [
  { label: 'Início', path: '/' },
  { label: 'Medicina', path: '/medicina' },
  { label: 'Aplicação de Exames' },
];

export function ExamApplicationPage() {
  const permissoes = usePermissoesDaAplicacao('exam');
  return <InventarioDoDestino config={CONFIG_DE_EXAMES} breadcrumbs={MIGALHAS} permissoes={permissoes} />;
}

export default ExamApplicationPage;
